import { cookieName, deviceName } from "./constant";

export function getUserIdFromCookie() {
  //  const cookieArray = document.cookie.split(';');
  //  for (let i = 0; i < cookieArray.length; i++) {
  //    const cookie = cookieArray[i].trim();
  //    if (cookie.startsWith(`${cookieName}=`)) {
  //      return cookie.substring(`${cookieName}=`.length);
  //    }
  //  }
  let uuid = sessionStorage.getItem("uuid");
   return uuid;
 }
 export function getDeviceId() {
    return localStorage.getItem(deviceName);
}